<div class='container-lg list-container mt-2'>
  <h2 class='card-title'
      *ngIf='loaded'>User Details</h2>
  <h2 class='card-title'
      [hidden]='loaded'>Loading User Details...</h2>
  <div class='row mb-3'>
    <div class='col-6 col-md-4 col-xl-3'>
      <small>DISPLAY NAME</small>

      <div [hidden]='!loaded' class='font-16'>{{user?.data?.displayName}}</div>
    </div>
    <div class='col-6 col-md-4 col-xl-3'>
      <small>USER ID</small>
      <div [hidden]='!loaded' class='font-16'>
        {{user?.data?.uid}}

      </div>
    </div>
    <div class='col-6 col-md-4 col-xl-3'>

      <small>USER EMAIL</small>
      <div class='font-16'>

        {{user?.data?.email || "No User Email"}}
      </div>


    </div>

    <div class='col-6 col-md-4 col-xl-3'>

      <small>ORG ID</small>
      <div class='font-16'>

        {{user?.data?.orgId}}
        <button class='btn btn-link m-0 mb-1' (click)='navigateToOrg(user?.data?.orgId)' *ngIf='userRole==="superuser"'>Org. details ></button>
      </div>


    </div>

    <button class='btn btn-link' [hidden]='!loaded'
            (click)='editUserActivation(user)'><small>{{user?.data?.active ? "Deactivate" : "Activate"}} User
    </small></button>
  </div>

  <div class='row mb-3' [hidden]='!loaded' *ngIf='userRole==="superuser"'>
    <div class='col-12'><h2
      class='col-12 d-inline pl-0'>Enabled Test Types</h2> (these will override org-level test types)
    </div>
    <div class='col-12 d-flex align-items-center mt-3 mb-2'>
      <label class='switch mr-2'>
        <input type='checkbox' [checked]='this.userCustomTestsEnabled' (click)='changeUserLevel()'>
        <span class='slider round'></span>
      </label>
      Custom Settings
    </div>
    <div class='col-md-3 col-12'>
      <form *ngIf='form' [formGroup]='form' novalidate class='d-flex flex-column'>
        <div *ngFor='let testType of testTypes'>
          <label class='d-flex justify-content-between'>
            <div class='d-flex align-items-center'>
              <input type='checkbox'
                     [disabled]='!userCustomTestsEnabled || (this.hiddenTests && this.hiddenTests.includes(testType.value))'
                     [checked]='user?.data?.enabledTests?.includes(testType.value) || (!user.data?.enabledTests && org?.enabledTests?.includes(testType.value)) || (user.data?.enabledTests && user.data?.enabledTests.length===0 && org?.enabledTests?.includes(testType.value))'
                     [value]='testType.value'
                     (change)='onCheckboxChange($event)' class='mr-1'/>
              <span [ngClass]='{"text-muted":this.hiddenTests?.includes(testType.value)}'>{{testType.name}}</span>
            </div>
            <button class='btn btn-link p-0'
                    [disabled]='!userCustomTestsEnabled' (click)='hideTestType(testType.value)'>
              <small>{{this.hiddenTests?.includes(testType.value) ? "Show" : "Hide"}}</small></button>
          </label>
        </div>
      </form>
    </div>
  </div>
</div>
